import { themes } from 'src/theme/theme';
import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: 56,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1000, // Keeps it above other elements
    backgroundColor: themes.light.loadingBarBackground[1], // Semi-transparent overlay
    justifyContent: 'flex-start', // Ensures progress bar stays at the top
  },
});
